<template>
    <div id="mail-integration-detail">
        <div class="wrapper">
            <div class="toolbar">
                <div class="left">
                    <IconButton :on-click="() => $router.push('/integrations/mail')">
                        <span class="material-icons"> chevron_left </span>
                    </IconButton>
                    <div class="icon-container">
                        <img :src="logoUrl" />
                    </div>
                    <div class="name">{{ $t("mail.mailDetail") }}: {{ selectedMail ? selectedMail.mail : "" }}</div>
                </div>
                <div class="right">
                    <a-button type="danger" @click="deleteMailAddress()">
                        {{ $t("chatbotv2.delete") }}
                    </a-button>
                </div>
            </div>
            <div class="channel-content">
                <div class="left">
                    <Menus v-model="currentTab" />
                </div>
                <div class="page-content">
                    <div v-if="currentTab === menuTypes.INTEGRATION.id">
                        <Integration />
                    </div>
                    <div v-if="currentTab === menuTypes.SENDER.id">
                        <SenderMailAddress />
                    </div>
                    <div v-if="currentTab === menuTypes.SIGNATURE.id">
                        <Signature />
                    </div>
                    <div v-if="currentTab === menuTypes.INBOX.id">
                        <Mails :selectedMail="selectedMail" />
                    </div>
                    <div v-if="currentTab === menuTypes.MEDIA.id">
                        <Medias />
                    </div>
                    <div v-if="currentTab === menuTypes.VISIBILITY.id">
                        <VisibilityChanger :alertMessage="false" />
                    </div>
                    <div v-if="currentTab === menuTypes.CONTACTS.id">
                        <MailVisitors />
                    </div>
                </div>
                <div class="page-content"></div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import WhatsappIcon from "../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import IconButton from "../Settings/components/IconButton.vue";
import Menus from "./Detail/Menus.vue";
import MenuTypes from "./Detail/MenuTypes";
import Integration from "./Detail/EmailIntegration.vue";
import SenderMailAddress from "./Detail/SenderMailAddress.vue";
import Mails from "./Detail/Mails.vue";
import Medias from "./Detail/Medias.vue";
import Signature from "./Detail/Signature.vue";
import VisibilityChanger from "./Detail/VisibilityChanger.vue";
import MailVisitors from "./Detail/MailVisitors.vue";
import { DEFAULT_ORGANIZATION_LOGO_URL } from "../../../utils/staticDatas";
import { sendSocketMessage } from "../../../utils/socketStream";
import { PERMISSION_TYPES } from "../../../language/permissionTypes";

const log = log2("MailIntegrationDetail.vue");
export default Vue.extend({
    name: "MailIntegrationDetail",
    components: {
        MailVisitors,
        VisibilityChanger,
        Menus,
        WhatsappIcon,
        IconButton,
        Integration,
        Mails,
        Medias,
        Signature,
        SenderMailAddress,
    },
    data() {
        const path = (_.last(this.$route.path.split("/")) || "detail").toLowerCase().trim();
        const selected = Object.values(MenuTypes).find((x) => x.path === path);
        return {
            currentTab: selected ? selected.id : "integration",
            selectedId: this.$route.params.id,
            selectedMail: {},
            menuTypes: MenuTypes,
            logoUrl: DEFAULT_ORGANIZATION_LOGO_URL,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            allMailAddresses: (state) => state.mail.allMailAddresses,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        isMailUpdatePermission() {
            return this.checkPermission(PERMISSION_TYPES["mail.update"].tr.name);
        },
        isMailDeletePermission() {
            return this.checkPermission(PERMISSION_TYPES["mail.delete"].tr.name);
        },
    },
    methods: {
        ...mapActions({}),
        ...mapMutations({
            DELETE_MAIL_ADDRESS: "mail/DELETE_MAIL_ADDRESS",
            DELETE_SENDER_MAIL_ADDRESSES: "mail/DELETE_SENDER_MAIL_ADDRESSES",
        }),
        changePage(page) {
            this.currentTab = page;
        },
        deleteMailAddress() {
            if (!this.isMailDeletePermission) {
                this.$message.error(this.$t("noPermission"));
            } else {
                console.log("deleteMailAddress-->", this.selectedMail);
                this.$confirm({
                    title: this.$t("mail.deleteMailTitle"),
                    content: this.$t("mail.deleteMailDesc"),
                    okText: this.$t("chatbotv2.yes"),
                    okType: "danger",
                    cancelText: this.$t("chatbotv2.no"),
                    onOk: () => {
                        if (!!this.selectedMail.user) {
                            sendSocketMessage("email delete_user_email", {
                                siteId: this.site._id,
                                mailAddressId: this.selectedMail._id,
                                identity: this.selectedMail.mail,
                            });
                            const otherUserMails = this.allMailAddresses.filter(
                                (x) =>
                                    x.type === "user" &&
                                    x._id !== this.selectedMail._id &&
                                    !!x.isSender &&
                                    !!x.isVerified
                            );
                            if (otherUserMails.length > 0) {
                                this.DELETE_MAIL_ADDRESS(this.selectedMail);
                            } else {
                                this.DELETE_SENDER_MAIL_ADDRESSES(this.selectedMail._id);
                            }
                            this.$router.replace("/integrations/mail");
                        } else {
                            sendSocketMessage("email delete_department_email", {
                                siteId: this.site._id,
                                senderMailId: this.selectedMail._id,
                                identity: this.selectedMail.mail,
                            });
                            this.DELETE_MAIL_ADDRESS(this.selectedMail);
                            this.$router.replace("/integrations/mail");
                        }
                        this.$message.success("Mail address deleted successfully");
                    },
                });
            }
        },
    },
    mounted() {
        this.selectedMail = this.allMailAddresses.find(
            (email) => email._id === this.selectedId || (email.department && email.department._id === this.selectedId)
        );
    },
    beforeMount() {
        if (!this.isMailUpdatePermission) {
            return this.$router.push("/denied");
        }
    },

    watch: {
        allMailAddresses(value) {
            console.log("mail integration detail allMailAddresses", value);
            this.selectedMail = value.find(
                (email) =>
                    email._id === this.selectedId || (email.department && email.department._id === this.selectedId)
            );
        },
        currentTab(value) {
            const selected = Object.values(MenuTypes).find((x) => x.id === value);
            const type = this.$route.params.type;
            if (selected) {
                this.$router.push(`/integrations/mail/${this.selectedId}/${type}/detail/${selected.path}`);
            }
        },
    },
});
</script>

<style scoped lang="scss">
#mail-integration-detail {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;

    .wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        .toolbar {
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 50px;
            border: 1px solid var(--color-border-default);

            .left {
                display: flex;
                align-items: center;
                gap: 5px;

                .name {
                    font-size: 18px;
                    font-weight: 700;
                }

                .icon-container {
                    width: 30px;
                    height: 30px;
                    display: flex;
                    margin: 0 auto;
                    align-items: center;
                    justify-content: center;
                    margin-right: 10px;
                }
            }

            .right {
                display: flex;
                justify-content: flex-end;
                gap: 5px;
            }
        }

        .channel-content {
            display: flex;
            height: 100%;

            .left {
                width: 275px;
                height: 100%;

                .channel-menu {
                    width: 100%;
                }
            }

            .page-content {
                width: calc(100% - 275px);
                height: 100%;
            }
        }
    }
}
</style>
